import { ApolloClient, ApolloLink, InMemoryCache, createHttpLink, Observable } from "@apollo/client";

import Cookies from "universal-cookie";
import { onError } from "@apollo/client/link/error";
import { setContext } from "@apollo/client/link/context";
import { showAlert } from "./helper";
import axios, { AxiosRequestConfig, AxiosResponse } from "axios";
const { CancelToken } = axios;

// Environment Variables
export const HOST = !!process.env.REFURB_BACKEND_HOST
  ? process.env.REFURB_BACKEND_HOST
  : "https://refurbishment-dev.spinnyworks.in";
export const SPINNY_WEB_HOST = !!process.env.SPINNY_WEB_HOST
  ? process.env.SPINNY_WEB_HOST
  : "https://spntest.myspinny.com";
export const CAT_HOST = !!process.env.CAT_HOST
  ? process.env.CAT_HOST
  : "https://catalogue-inventory-management-dev.spinnyworks.in";
export const PUSHER_WHATSAPP_KEY = !!process.env.PUSHER_WHATSAPP_KEY ? process.env.PUSHER_WHATSAPP_KEY : "";
export const BUILD_ENV = !!process.env.BUILD_ENV ? process.env.BUILD_ENV : "development";
export const VERSION = require("../version.json").version;
export const IS_DEV_ENV = HOST === "https://refurbishment-dev.spinnyworks.in";
export const IS_STAG_ENV = HOST === "https://refurbishment-dev-1.spinny.com";
// Common Variables
// export const FRONT_END_SERVER_HOST = IS_DEV_ENV ? 'https://refurb-qa.spinnyworks.in/' : IS_STAG_ENV ? 'https://refurb-qa.spinnyworks.in/' : "https://refurb.spinnyworks.in/";
export const FRONT_END_SERVER_HOST = `${window.location.origin}/`;
export const VOC_URL =
  "https://ticket-master-crm.dev.ispinnyworks.in/voc-form";
export const DASHBOARD_DOMAIN = window.location.origin;
export const REFURB_TOKEN = "token";
export const SSO_TOKEN = "sso_token";
export const SPINNY_WEB_TOKEN = "spinny_web_token";
export const SPINNY_WEB_TOKEN_REST = "spinny_rest_web_token";
export const SPINNY_WEB_TOKEN_REST_REFRESH = "spinny_rest_web_token_refresh";
export const CAT_TOKEN = "cat_jwt_token";

// Derived Variables
// HOST AKA REFURB HOST
export const DOWNLOAD_INVOICE_REPORT_TOKEN_URL = `${HOST}/external/api/temp-token/workshop-invoice-report`;
export const DOWNLOAD_INVOICE_PDF_TOKEN_URL = `${HOST}/external/api/temp-token/invoice-pdf`;
export const UPLOAD_CAR_PHOTOS_URL = `${HOST}/upload-miscellaneous-car-photos`;
export const GET_VAHAN_VERDICT_AND_SERVICE_HISTORY_URL = (refurbCarId) =>
  `${HOST}/get-vaahan-verdict-and-service-history?refurb_car_id=${refurbCarId}`;
export const GET_REPORT_DATA_URL = (reportId) => `${HOST}/report-data/get/${reportId}`;
const JOB_LIST_VIEW_URL = `${HOST}/external/view-job-list/`;
export const getJobListViewURLForLeadId = (leadId) => `${JOB_LIST_VIEW_URL}${leadId}`;
const HOST_GRAPHQL_LINK = `${HOST}/graphql`;
const HOST_GRAPHQL_V2_LINK = `${HOST}/graphql/v2`;
export const HOST_GRAPHQL_V3_LINK = `${HOST}/graphql/v3`;
const REFURB_GRAPHQL_V2_DIRECT_LINK = `${HOST}/graphql/v2`;
const HOST_GRAPHQL_V2_EXTERNAL_LINK=`${HOST}/external/graphql/v2`;
const HOST_GRAPHQL_EXTERNAL_LINK=`${HOST}/external/graphql`;
// SPINNY_WEB_HOST
export const LEAD_INFO_URL = (leadId) => `${SPINNY_WEB_HOST}/api/leads/${leadId}/refurb_info/`;
export const SPINNY_REST_JWT_TOKEN_URL = `${SPINNY_WEB_HOST}/api/c/jwt_token/`;
export const SPINNY_FILE_UPLOAD_URL = `${SPINNY_WEB_HOST}/api/upload/`;
export const SPINNY_REST_JWT_TOKEN_REFRESH_URL = `${SPINNY_WEB_HOST}/api/c/jwt_refresh/`;
const SPINNY_WEB_PUBLIC_GRAPHQL_LINK = `${SPINNY_WEB_HOST}/api/hub/graphql_public`;
const SPINNY_WEB_WHATSAPP_GRAPHQL_LINK = `${SPINNY_WEB_HOST}/api/whatsapp/graphql/`;

// CAT_HOST
export const SPINNY_FILE_UPLOAD_FOR_CATALOGUE = `${CAT_HOST}/file/upload-file`;
export const REFURB_CATALOGUE_REQUEST_DOWNLOAD_URL = (requestSlug) => `${CAT_HOST}/request/get-request/${requestSlug}`;
export const REFURB_CATALOGUE_VENDOR_PURCHASE_REQUEST_URL = (requestSlug, vendorSlug, isRequestedQtySelected, isPdf) =>
  `${CAT_HOST}/request/get-request-for-vendor/${requestSlug}/${vendorSlug}${isPdf ? "/pdf" : ""}${isRequestedQtySelected ? "?requested_quantity_pdf" : ""}`;
export const REFURB_CATALOGUE_VENDOR_ISSUE_REQUEST_URL = (requestSlug) =>
  `${CAT_HOST}/request/get-issue-request/${requestSlug}`;
export const SPARE_GET_INSPECTION_CAR_PHOTOS = (requestSlug) =>
  `${CAT_HOST}/request/get-inspection-car-photos${requestSlug}`;
export const SPARE_PARTS_GENERATE_PUTAWAY_LIST_URL = (entityId, documentId) =>
  `${CAT_HOST}/vendor/get-vendor-put-away-list/${entityId}/${documentId}`;
export const REFURB_CATALOGUE_CSV_REQUEST_URL = (pageUrl, params = {}) => {
  const entityId = localStorage.getItem("default_entity_id");
  let url = `${CAT_HOST}/api/temp-token/${pageUrl}/${entityId}`;
  if (Object.keys(params)?.length > 0)
    Object?.keys(params)?.map((key) => (url = appendParams(url, key, encodeURIComponent(params[key]))));
  return url;
};

export const REFURB_CATALOGUE_GET_ALL_PRODUCTS_URL = (params = {}) => {
  let url = `${CAT_HOST}/catalogue/get-all-products/`;
  if (Object.keys(params)?.length > 0)
    Object?.keys(params)?.map((key) => (url = appendParams(url, key, encodeURIComponent(params[key]))));
  return url;
};


export const CAT_HOST_AUTH = `${CAT_HOST}/auth/get-jwt-token`;
export const CAT_HOST_ACCESS = `${CAT_HOST}/auth/get-user-access`;
export const CAT_TAB_ACCESS = `${CAT_HOST}/auth/get-user-accessible-screens`;
const CAT_GRAPHQL_LINK = `${CAT_HOST}/v1/graphql`;
const CAT_GRAPHQL_LINK_EXTERNAL = `${CAT_HOST}/external/v1/graphql`
export const LOCAL_VERSION_API = `${DASHBOARD_DOMAIN}/build/static/media/version.json`;
export const RECAPTCHA_SITE_KEY =
  IS_DEV_ENV || IS_STAG_ENV
    ? "6Lc4dKkoAAAAADTjL9IWN_jadY4_evs-r2258p1d"
    : "6Lc_rqYoAAAAAHwcTbMntlDkC52H6QAYgYE7eUKp";

const catHttpLink = createHttpLink({
  uri: CAT_GRAPHQL_LINK,
  credentials: "include",
});

const catHttpLinkExternal = createHttpLink({
  uri: CAT_GRAPHQL_LINK_EXTERNAL,
  credentials: "include",
});

const httpLink = createHttpLink({
  uri: HOST_GRAPHQL_LINK,
  credentials: "include",
});

const httpLinkV2 = createHttpLink({
  uri: HOST_GRAPHQL_V2_LINK,
  credentials: "include",
});

const httpLinkV2Direct = createHttpLink({
  uri: REFURB_GRAPHQL_V2_DIRECT_LINK,
  credentials: "include",
});

const httpExternalLinkV2= createHttpLink({
  uri: HOST_GRAPHQL_V2_EXTERNAL_LINK,
  credentials: "include",
});
const httpExternalLink= createHttpLink({
  uri: HOST_GRAPHQL_EXTERNAL_LINK,
  credentials: "include",
});

const cache = new InMemoryCache({
  typePolicies: {
    Query: {
      fields: {
        getRejectedProductSkus: {
          keyArgs: ["search", "filters", "orderBy"], //By default, all GraphQL arguments are key arguments
          merge(exisiting = { data: [] }, incoming, { variables: { page } }: any) {
            if (page == 1) return incoming;
            if (!incoming) return exisiting;
            const prevData = exisiting?.data;
            const newData = incoming?.data;

            const mergedData = [...prevData, ...newData];
            const d = { ...incoming, data: mergedData };
            return d;
          },
        },
      },
    },
  },
});

const cache_v2 = new InMemoryCache({
  typePolicies: {
    Query: {
      fields: {
        getInventory: {
          keyArgs: ["filters", "search", "orderBy"], //By default, all GraphQL arguments are key arguments
          merge(exisiting = { data: [] }, incoming, { variables: { page } }: any) {
            if (page == 1) return incoming;
            if (!incoming) return exisiting;
            const prevData = exisiting?.data;
            const newData = incoming?.data;
            const mergedData = [...prevData, ...newData];
            const d = { ...incoming, data: mergedData };
            return d;
          },
        },
        getUpcomingInventory: {
          keyArgs: ["filters", "search", "orderBy"], //By default, all GraphQL arguments are key arguments
          merge(exisiting = { data: [] }, incoming, { variables: { page } }: any) {
            if (page == 1) return incoming;
            if (!incoming) return exisiting;
            const prevData = exisiting?.data;
            const newData = incoming?.data;
            const mergedData = [...prevData, ...newData];
            const d = { ...incoming, data: mergedData };
            return d;
          },
        },
        getRefurbCarListing: {
          keyArgs: ["filters", "search", "orderBy"], //By default, all GraphQL arguments are key arguments
          merge(exisiting = { data: [] }, incoming, { variables: { page } }: any) {
            if (page == 1) return incoming;
            if (!incoming) return exisiting;
            const prevData = exisiting?.data;
            const newData = incoming?.data;
            console.log("prevData, newData", prevData, newData);
            const mergedData = [...prevData, ...newData];
            const d = { ...incoming, data: mergedData };
            return d;
          },
        },
        getRefurbCarListingForInventoryStats: {
          keyArgs: ["filters", "search", "orderBy"], //By default, all GraphQL arguments are key arguments
          merge(exisiting = { data: [] }, incoming, { variables: { page } }: any) {
            if (page == 1) return incoming;
            if (!incoming) return exisiting;
            const prevData = exisiting?.data;
            const newData = incoming?.data;
            console.log("prevData, newData", prevData, newData);
            const mergedData = [...prevData, ...newData];
            const d = { ...incoming, data: mergedData };
            return d;
          },
        },
        jobListListingForCityTeam: {
          keyArgs: ["filters", "search", "orderBy"],
          merge(exisiting = { data: [] }, incoming, { variables: { page } }: any) {
            if (page == 1) return incoming;
            if (!incoming) return exisiting;
            const prevData = exisiting?.data;
            const newData = incoming?.data;

            const mergedData = [...prevData, ...newData];
            const d = { ...incoming, data: mergedData };
            return d;
          },
        },
        getRefurbCarListingV2: {
          keyArgs: ["filters", "search", "orderBy"], //By default, all GraphQL arguments are key arguments
          merge(exisiting = { data: [] }, incoming, { variables: { page } }: any) {
            if (page == 1) return incoming;
            if (!incoming) return exisiting;
            const prevData = exisiting?.data;
            const newData = incoming?.data;
            console.log("prevData, newData", prevData, newData);
            const mergedData = [...prevData, ...newData];
            const d = { ...incoming, data: mergedData };
            return d;
          },
        },
      },
    },
  },
});

const authLink = new ApolloLink((operation, forward) => {
  const isWorkshopIdRequired = operation.query.definitions?.[0]?.variableDefinitions?.find(
    (def) => def.variable?.name?.value === "workshopId"
  );

  if (!!isWorkshopIdRequired) {
    operation.variables["workshopId"] = localStorage.getItem("workshopId");
  }

  operation.setContext(({ headers }) => {
    // get the authentication token from local storage if it exists
    // return the headers to the context so httpLink can read them
    const token = localStorage.getItem(REFURB_TOKEN);

    return {
      headers: {
        ...headers,
        "Keycloak-Authorization": token !== "" ? `bearer ${token}` : "",
      },
    };
  });

  return forward(operation);
});

const ssoAuthLink = new ApolloLink((operation, forward) => {
  const isWorkshopIdRequired = operation.query.definitions?.[0]?.variableDefinitions?.find(
    (def) => def.variable?.name?.value === "workshopId"
  );

  if (!!isWorkshopIdRequired) {
    operation.variables["workshopId"] = localStorage.getItem("workshopId");
  }

  operation.setContext(({ headers }) => {
    const token = localStorage.getItem(SSO_TOKEN);

    return {
      headers: {
        ...headers,
        "Keycloak-Authorization": token !== "" ? `bearer ${token}` : "",
      },
    };
  });

  return forward(operation);
});

// const authLink = setContext((_, {headers}) => {
//     // get the authentication token from local storage if it exists
//     // return the headers to the context so httpLink can read them
//     const token = localStorage.getItem(REFURB_TOKEN);

//     return {
//         headers: {
//             ...headers,
//             Authorization: token ? `JWT ${token}` : "",
//         }
//     }
// });

const catAuthLink = new ApolloLink((operation, forward) => {
  const isEntityIdRequired = operation.query.definitions?.[0]?.variableDefinitions?.find(
    (def) => def.variable?.name?.value === "entityId"
  );

  if (!!isEntityIdRequired) {
    operation.variables["entityId"] = localStorage.getItem("default_entity_id");
  }

  operation.setContext(({ headers }) => {
    // get the authentication token from local storage if it exists
    // return the headers to the context so httpLink can read them
    const cat_token = localStorage.getItem(CAT_TOKEN);
    const customHeader = {
      ...headers,
    };
    if (cat_token) customHeader["Keycloak-Authorization"] = cat_token !== "" ? `bearer ${cat_token}` : "";

    return {
      headers: {
        ...customHeader,
      },
    };
  });

  return forward(operation);
});

const errorExcluded = ["Auth", "getNotificationCount", "setDeviceRegistrationToken", "removeDeviceRegistrationToken"];

const errorLink = onError(({ graphQLErrors, networkError, operation, forward }) => {
  if (graphQLErrors && !errorExcluded.includes(operation.operationName)) {
    showAlert(graphQLErrors?.[0]?.message, "error");
  } else if (networkError) {
    let statusCode = networkError?.statusCode;
    if (statusCode === 401 || statusCode === 403) {
      // Skip token refresh for excluded operations (e.g. removeDeviceRegistrationToken
      // fired during logout). Without this guard the failed refresh would call
      // handleTokenRefreshFailure → redirectToKeycloakLogin, overwriting the
      // logout redirect and causing the user to be auto-authenticated again.
      if (errorExcluded.includes(operation.operationName)) {
        return;
      }
      return new Observable((observer) => {
        import("./keycloakAuth")
          .then(({ refreshAccessToken }) => refreshAccessToken())
          .then(() => {
            const accessToken = localStorage.getItem(SSO_TOKEN);
            operation.setContext(({ headers }) => ({
              headers: {
                ...headers,
                "Keycloak-Authorization": accessToken ? `bearer ${accessToken}` : "",
              },
            }));
            const subscriber = {
              next: observer.next.bind(observer),
              error: observer.error.bind(observer),
              complete: observer.complete.bind(observer),
            };
            forward(operation).subscribe(subscriber);
          })
          .catch(() => {
            handleTokenRefreshFailure();
          });
      });
    } else if (!errorExcluded.includes(operation.operationName))
      showAlert(`Error fetching data ${statusCode ?? ""}`, "error");
  }
});

const ssoErrorLink = onError(({ networkError }) => {
  if (networkError) {
    showAlert(`Error fetching data ${networkError?.statusCode ?? ""}`, "error");
  }
});

export const client = new ApolloClient({
  link: ApolloLink.from([errorLink, authLink, httpLink]),
  cache,
});

export const clientV2 = new ApolloClient({
  link: ApolloLink.from([errorLink, authLink, httpLinkV2]),
  cache: cache_v2,
});

export const clientExternalV2 = new ApolloClient({
  link: ApolloLink.from([errorLink, authLink, httpExternalLinkV2]),
  cache: cache_v2,
});

export const clientExternal = new ApolloClient({
  link: ApolloLink.from([errorLink, authLink, httpExternalLink]),
  cache: cache_v2,
});

export const ssoClientV2 = new ApolloClient({
  link: ApolloLink.from([ssoErrorLink, ssoAuthLink, httpLinkV2Direct]),
  cache: cache_v2,
});

export const catClient = new ApolloClient({
  link: ApolloLink.from([errorLink, catAuthLink, catHttpLink]),
  cache,
});

export const catClientExternal = new ApolloClient({
  link: ApolloLink.from([errorLink, catAuthLink, catHttpLinkExternal]),
  cache,
});

const spinnyWebAuthLink = setContext((_, { headers }) => {
  const spinny_web_token = localStorage.getItem(SPINNY_WEB_TOKEN);
  return {
    headers: {
      ...headers,
      "Keycloak-Authorization": spinny_web_token !== "" ? `bearer ${spinny_web_token}` : "",
    },
  };
});

const spinnyWebHttpLoginLink = createHttpLink({
  uri: SPINNY_WEB_PUBLIC_GRAPHQL_LINK,
  credentials: "include",
});

const spinnyWebCache = new InMemoryCache();

export const spinnyWebLoginClient = new ApolloClient({
  link: spinnyWebAuthLink.concat(spinnyWebHttpLoginLink),
  cache: spinnyWebCache,
});

const whatsAppHttpLink = createHttpLink({
  uri: SPINNY_WEB_WHATSAPP_GRAPHQL_LINK,
  credentials: "include",
});

const whatsAppCache = new InMemoryCache();
export const inrFormat = (inr) => {
  return inr.toLocaleString("en-IN", {
    maximumFractionDigits: 1,
    style: "currency",
    currency: "INR",
  });
};
export const whatsAppClient = new ApolloClient({
  link: spinnyWebAuthLink.concat(whatsAppHttpLink),
  cache: whatsAppCache,
});

// export const inrFormat=(inr)=>{
//     return inr.toLocaleString("en-IN", {
//       maximumFractionDigits: 1,
//       style: "currency",
//       currency: "INR",
//     });
// }

// const expires=100
const cookies = new Cookies();
export const setCookie = (value, data) =>
  cookies.set(value, data, {
    path: "/",
    // maxAge: expires,
  });
export const removeCookie = (val) => cookies.remove(val, { path: "/" });
export const getCookie = (val) => cookies.get(val);

export function capitalizeFirstLetter(string) {
  string = string.toLowerCase();
  return string?.charAt(0)?.toUpperCase() + string?.slice(1);
}

const URL = `${HOST}/api`;

export const convertToFormData = (data) => {
  const formData = new URLSearchParams();
  for (const [key, value] of Object.entries(data)) {
    //@ts-ignore
    formData.append(key, value);
  }
  return formData;
};

const getCurrentAccessToken = (tokenType) => {
  if (tokenType === "refurb") return localStorage.getItem(REFURB_TOKEN);
  else if (tokenType === "spares") return localStorage.getItem(CAT_TOKEN);
  else if (tokenType === "spinnyWeb") return localStorage.getItem(SPINNY_WEB_TOKEN_REST);
  else if (tokenType === "sso") return localStorage.getItem(SSO_TOKEN);
};

/**
 * Refresh the SSO token using the refresh_token grant.
 * On success the new tokens are persisted and returned.
 * On failure the user is redirected to Keycloak login.
 */
export const getSSOToken = async (accessToken, userCreds) => {
  try {
    const { refreshAccessToken } = await import("./keycloakAuth");
    return await refreshAccessToken();
  } catch {
    handleTokenRefreshFailure();
  }
};

/**
 * Global flag set by performLogout() so that handleTokenRefreshFailure
 * (triggered by async 401s from fire-and-forget mutations) does NOT
 * overwrite the Keycloak LOGOUT redirect with a LOGIN redirect.
 */
export let _logoutInProgress = false;
export const setLogoutInProgress = (value: boolean) => {
  _logoutInProgress = value;
};

/**
 * Handles token refresh failure by clearing all auth data and redirecting
 * to Keycloak login. Uses a simple `redirecting` guard to prevent duplicate
 * redirects from concurrent 401s.
 *
 * Skipped entirely when a logout is already in progress.
 */
let _redirecting = false;
const handleTokenRefreshFailure = () => {
  if (_logoutInProgress) return;
  if (_redirecting) return;
  _redirecting = true;

  // Clear all auth tokens
  localStorage.clear();

  // Redirect to Keycloak login
  import("./keycloakAuth")
    .then(({ redirectToKeycloakLogin }) => {
      redirectToKeycloakLogin(`${FRONT_END_SERVER_HOST}Login`);
    })
    .catch(() => {
      window.location.href = `${FRONT_END_SERVER_HOST}Login`;
    });
};

const appendParams = (url, newParam, newValue) => {
  let finalUrl = url;
  if (!url.includes(newParam)) {
    if (url.includes("?")) finalUrl += `&${newParam}=${newValue}`;
    else finalUrl += `?${newParam}=${newValue}`;
  }

  return finalUrl;
};

type TokenType = "refurb" | "spares" | "spinnyWeb" | "sso";

export const makeGetApiRequest = async <T = any>(
  baseUrl: string,
  options: AxiosRequestConfig,
  authHeader: string,
  prefix: string,
  tokenType: TokenType
): Promise<AxiosResponse<T>> => {
  const headers = options.headers || {};
  const entityId = localStorage.getItem("default_entity_id");
  let url = baseUrl;
  const cancelTokenSource = CancelToken.source();
  const axiosInstance = axios.create();
  axiosInstance.defaults.cancelToken = cancelTokenSource.token;
  if (entityId && entityId !== "undefined")
    url = appendParams(baseUrl, "entity_id", localStorage.getItem("default_entity_id"));
  try {
    headers[authHeader] = `${prefix ? `${prefix} ` : ""}${getCurrentAccessToken(tokenType)}`;

    const response = await axiosInstance.get(url, { ...options, headers });

    return response;
  } catch (error) {
    let response = error?.response;
    let statusCode = response?.status;

    if (statusCode !== 403 && response?.data?.data) showAlert(response?.data?.data, "error");

    if (statusCode === 401 || statusCode === 403) {
      try {
        const { refreshAccessToken } = await import("./keycloakAuth");
        const { access_token } = await refreshAccessToken();

        headers[authHeader] = `${prefix ? `${prefix} ` : ""}${access_token}`;
        return axios.get(url, { ...options, headers });
      } catch {
        handleTokenRefreshFailure();
        return Promise.reject(error);
      }
    }

    return Promise.reject(error);
  }
};

export const makePostApiRequest = async <T = any>(
  url: string,
  data: any,
  options: AxiosRequestConfig,
  authHeader: string,
  prefix: string,
  tokenType: TokenType
): Promise<AxiosResponse<T>> => {
  const headers = options.headers || {};
  try {
    headers[authHeader] = `${prefix ? `${prefix} ` : ""}${getCurrentAccessToken(tokenType)}`;

    const response = await axios.post(url, data, { ...options, headers });
    console.log("response post", response);

    return response;
  } catch (error) {
    let response = error?.response;
    let statusCode = response?.status;

    if (statusCode !== 403 && response?.data?.data) showAlert(response?.data?.data, "error");

    if (statusCode === 401 || statusCode === 403) {
      try {
        const { refreshAccessToken } = await import("./keycloakAuth");
        const { access_token } = await refreshAccessToken();

        headers[authHeader] = `${prefix ? `${prefix} ` : ""}${access_token}`;
        return axios.post(url, data, { ...options, headers });
      } catch {
        handleTokenRefreshFailure();
        return Promise.reject(error);
      }
    }

    return Promise.reject(error);
  }
};
